export const dataFooter = [
    {
        id: 0,
        cont: "PHONE",
        text: "+(111) 111-11"
    },
  
    {
        cont: "ADDRESS",
        text: "6 SOUTHWARK ST, LONDON"
    },
      {
        cont: "HOURS",
        text: "8AM - 10PM"
    },

    {
        cont: "EMAIL",
        text: "INFO@COTALKS.COM"
    }

  ]